angular
  .module('contabilidad.cheques')
  .service('ContabilidadCheques', ContabilidadCheques)

ContabilidadCheques.$inject = ['$api', '$export']

function ContabilidadCheques ($api, $export) {
  var Cheques = this

  Cheques.obtenerCheques = obtenerCheques
  Cheques.obtenerEmpresasClientes = obtenerEmpresasClientes
  Cheques.exportarXLS = exportarXLS

  function obtenerCheques (data) {
    return $api.get('kendu/contabilidad/cheques/obtenerCheques', {
      fecha_inicio: data.fecha_inicio.toYMD(),
      fecha_fin: data.fecha_fin.toYMD(),
      Cuenta: data.CuentaBancaria,
    })
  }

  function obtenerEmpresasClientes () {
    return $api.get('kendu/contabilidad/cheques/obtenerEmpresasClientes')
  }

  function exportarXLS (data, archivo) {

    var pages = [],
      cheques = data.map(function (item) {
        return [
          item['Folio'],
          item['Banco_Referencia'],
          item['Fecha_Movimiento'],
          item['Banco_Beneficiario'],
          item['Importe'],
          item['Banco_Status_Cheque_Des'] === 'En tránsito' ? item['Importe'] : 0,
          item['Banco_Status_Cheque_Des'],
          item['Notas'],
        ]
      })

    if (cheques.length > 0)
      pages.push(new Page(cheques))
    if (pages.length == 0)
      alert('No se encontraron servicios en el período seleccionado')
    else
      $export.excel(archivo, pages)
  }

  function Page (data) {
    return {
      name: 'Cheques',
      columns: [
        {label: 'Folio', format: {align: 'left', width: 10}},
        {label: 'Cheque', format: {width: 20}},
        {label: 'Fecha', format: {align: 'right', width: 10}},
        {label: 'Beneficiario', format: {width: 40}},
        {label: 'Importe', format: {type: 'currency', width: 12, align: 'right'}, totalize: true},
        {label: 'En tránsito', format: {type: 'currency', width: 12, align: 'right'}, totalize: true},
        {label: 'Estatus', format: {align: 'center', width: 20}},
        {label: 'Notas', format: {width: 100}},
      ],
      options: {
        logo: {
          filename: '/api/export/images/FAN-logo.png',
          title: 'FAN Consultores',
          cell: 'A1',
        },
        show_grid: false,
        fixed_column: 'A8',
      },
      data: data,
    }
  }
}




// WEBPACK FOOTER //
// ./src/contabilidad/cheques/services/ContabilidadCheques.js